import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { RedirectService } from './redirect.service';

@Injectable()
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    router: Router,
    protected readonly keycloak: KeycloakService,
    private readonly redirectService: RedirectService
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authenticated) {
      const redirectUrl = this.redirectService.redirectToCanonicalUrl();

      await this.keycloak.login({
        redirectUri: redirectUrl,
      });
    }
    return true;
  }
}
